import { IdAndNameModel } from './idAndName.model'

export class SerieDependency extends IdAndNameModel {
  constructor(id: number, name: string) {
    super(id, name)
  }
}
